import React from "react";
import { Redirect } from "react-router-dom";
import { Grid } from "semantic-ui-react";
import styled from "styled-components";
import { Paths } from "../Constants";
import BaseComponent from "./BaseComponent";
import AppHeaderSmall from "./common/AppHeaderSmall";
import Footer from "./common/Footer";
import MainContentWrapper from "./common/MainContentWrapper";
import SFCookieConsent from "./common/SFCookieConsent";
import SFLoader from "./common/SFLoader";
import SiteWrapper from "./common/SiteWrapper";
import ErrorDisplay from "./ErrorDisplay";

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 200px;
`;

const TextH1 = styled.h1`
  min-width: 400px;
  max-width: 600px;
  padding: 10px;
  font-size: 20px;
  text-align: center;
`;

class CheckAccountStatus extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      redirectPage: null,
      loaderActive: false,
    };
  }

  async componentDidMount() {
    this.setState({ loaderActive: true });
    try {
      //Email Confirmed
      let response = await this.identityUserApi.isEmailConfirmed();
      if (!response) {
        //need to go to email confirmation screen
        this.setState({
          loaderActive: false,
          redirectPath: Paths.CHECK_CONFIRMATION,
        });
        return;
      }

      //Profile filled out
      response = await this.safeFunApi.getCurrentUser();
      if (!response.data) {
        //Send to the personal info screen
        this.setState({ loaderActive: false, redirectPath: Paths.YOUR_INFO });
        return;
      }

      //Terms and Conditions and Privacy Policy Up to Date

      //get and set screen permissions
      await this.safeFunApi.getPermissions();

      //see if the user has any uploaded tests
      const testResultsResponse = await this.safeFunApi.getTestResults();

      this.setState({ loaderActive: false });

      if (
        testResultsResponse.data &&
        testResultsResponse.data.length &&
        testResultsResponse.data.length > 0
      ) {
        this.setState({ loaderActive: false, redirectPath: Paths.SAFE_WINDOW });
      } else {
        this.setState({ redirectPath: Paths.WELCOME });
      }
    } catch (err) {
      console.log(err);
      this.errorManager.addError(
        "There was an error looking up your account information"
      );
      this.errorManager.addError(err);
      this.setState({ loaderActive: false });
    }
  }

  render() {
    return (
      <SiteWrapper>
        {this.state.redirectPath ? (
          <Redirect
            to={{
              pathname: this.state.redirectPath,
              search: this.state.redirectSearch,
            }}
          />
        ) : null}
        <AppHeaderSmall />
        <SFLoader
          active={this.state.loaderActive}
          message="Making sure everything is looking good..."
        />
        <MainContentWrapper>
          <Grid textAlign="center" padded>
            <Grid.Column style={{ maxWidth: "600px", minWidth: "400px" }}>
              {this.errorManager.getErrorCount() > 0 ? (
                <ErrorDisplay errorManager={this.errorManager} />
              ) : null}
            </Grid.Column>
          </Grid>
        </MainContentWrapper>
        <Footer />
        <SFCookieConsent />
      </SiteWrapper>
    );
  }
}

export default CheckAccountStatus;
